import React from 'react';

import type { Client } from '@klp/client/classes';
import { ActionLink, Block, Heading } from '@klp/design';

interface IByggListHeaderProps {
    isAdmin: boolean;
    selectedClient?: Client;
    showAll: boolean;
    onShowAll: () => void;
    onNoShowAll: () => void;
}

export const ByggListHeader: React.FC<IByggListHeaderProps> = ({
    isAdmin,
    selectedClient,
    showAll,
    onShowAll,
    onNoShowAll,
}) => {
    return (
        <>
            {!isAdmin && (
                <Heading
                    translation="bygg.byggListTitle"
                    marginBottom="bulky"
                />
            )}
            {isAdmin && selectedClient && !showAll && (
                <Heading
                    klpHeadingLevel="ONE"
                    translation="bygg.byggListTitleAdmin"
                    translationOptions={{
                        customerName: selectedClient.kundeName,
                        customerNumber: selectedClient.kundeNummer,
                    }}
                    marginBottom="tiny"
                />
            )}
            {isAdmin && (!selectedClient || showAll) && (
                <Heading
                    klpHeadingLevel="ONE"
                    translation="bygg.byggListTitleAdminAllBuildings"
                    marginBottom="tiny"
                />
            )}

            {isAdmin && !!selectedClient && !showAll && (
                <Block align="left" marginBottom="bulky">
                    <ActionLink
                        actionType="link"
                        translation="bygg.showAll"
                        onClick={onShowAll}
                        data-testid="ByggList__ShowAll"
                    />
                </Block>
            )}

            {isAdmin && !!selectedClient && showAll && (
                <Block align="left" marginBottom="bulky">
                    <ActionLink
                        actionType="link"
                        translation="bygg.backToOverviewForClient"
                        translationOptions={{
                            customerName: selectedClient.kundeName,
                        }}
                        onClick={onNoShowAll}
                        data-testid="ByggList__NoShowAll"
                    />
                </Block>
            )}
        </>
    );
};
